


export const accountsCountries = new Map([
    [ "AF" , "Afghanistan" ],
    [ "AL" , "Albania" ],
    [ "DZ" , "Algeria" ],
    [ "AD" , "Andorra" ],
    [ "AO" , "Angola" ],
    [ "AG" , "Antigua and Barbuda" ],
    [ "AR" , "Argentina" ],
    [ "AM" , "Armenia" ],
    [ "AU" , "Australia" ],
    [ "AT" , "Austria" ],
    [ "AZ" , "Azerbaijan" ],
    [ "BS" , "Bahamas" ],
    [ "BH" , "Bahrain" ],
    [ "BD" , "Bangladesh" ],
    [ "BB" , "Barbados" ],
    [ "BY" , "Belarus" ],
    [ "BE" , "Belgium" ],
    [ "BZ" , "Belize" ],
    [ "BJ" , "Benin" ],
    [ "BT" , "Bhutan" ],
    [ "BO" , "Bolivia (Plurinational State of)" ],
    [ "BA" , "Bosnia and Herzegovina" ],
    [ "BW" , "Botswana" ],
    [ "BR" , "Brazil" ],
    [ "BN" , "Brunei Darussalam" ],
    [ "BG" , "Bulgaria" ],
    [ "BF" , "Burkina Faso" ],
    [ "BI" , "Burundi" ],
    [ "CV" , "Cabo Verde" ],
    [ "KH" , "Cambodia" ],
    [ "CM" , "Cameroon" ],
    [ "CA" , "Canada" ],
    [ "CF" , "Central African Republic" ],
    [ "TD" , "Chad" ],
    [ "CL" , "Chile" ],
    [ "CN" , "China" ],
    [ "CO" , "Colombia" ],
    [ "KM" , "Comoros" ],
    [ "CG" , "Congo" ],
    [ "CK" , "Cook Islands" ],
    [ "CR" , "Costa Rica" ],
    [ "HR" , "Croatia" ],
    [ "CU" , "Cuba" ],
    [ "CY" , "Cyprus" ],
    [ "CZ" , "Czechia" ],
    [ "CI" , "Côte d'Ivoire" ],
    [ "KP" , "Democratic People's Republic of Korea" ],
    [ "CD" , "Democratic Republic of the Congo" ],
    [ "DK" , "Denmark" ],
    [ "DJ" , "Djibouti" ],
    [ "DM" , "Dominica" ],
    [ "DO" , "Dominican Republic" ],
    [ "EC" , "Ecuador" ],
    [ "EG" , "Egypt" ],
    [ "SV" , "El Salvador" ],
    [ "GQ" , "Equatorial Guinea" ],
    [ "ER" , "Eritrea" ],
    [ "EE" , "Estonia" ],
    [ "SZ" , "Eswatini" ],
    [ "ET" , "Ethiopia" ],
    [ "FO" , "Faroe Islands" ],
    [ "FJ" , "Fiji" ],
    [ "FI" , "Finland" ],
    [ "FR" , "France" ],
    [ "GA" , "Gabon" ],
    [ "GM" , "Gambia" ],
    [ "GE" , "Georgia" ],
    [ "DE" , "Germany" ],
    [ "GH" , "Ghana" ],
    [ "GR" , "Greece" ],
    [ "GD" , "Grenada" ],
    [ "GT" , "Guatemala" ],
    [ "GN" , "Guinea" ],
    [ "GW" , "Guinea-Bissau" ],
    [ "GY" , "Guyana" ],
    [ "HT" , "Haiti" ],
    [ "HN" , "Honduras" ],
    [ "HU" , "Hungary" ],
    [ "IS" , "Iceland" ],
    [ "IN" , "India" ],
    [ "ID" , "Indonesia" ],
    [ "IR" , "Iran (Islamic Republic of)" ],
    [ "IQ" , "Iraq" ],
    [ "IE" , "Ireland" ],
    [ "IL" , "Israel" ],
    [ "IT" , "Italy" ],
    [ "JM" , "Jamaica" ],
    [ "JP" , "Japan" ],
    [ "JO" , "Jordan" ],
    [ "KZ" , "Kazakhstan" ],
    [ "KE" , "Kenya" ],
    [ "KI" , "Kiribati" ],
    [ "KW" , "Kuwait" ],
    [ "KG" , "Kyrgyzstan" ],
    [ "LA" , "Lao People's Democratic Republic" ],
    [ "LV" , "Latvia" ],
    [ "LB" , "Lebanon" ],
    [ "LS" , "Lesotho" ],
    [ "LR" , "Liberia" ],
    [ "LY" , "Libya" ],
    [ "LT" , "Lithuania" ],
    [ "LU" , "Luxembourg" ],
    [ "MG" , "Madagascar" ],
    [ "MW" , "Malawi" ],
    [ "MY" , "Malaysia" ],
    [ "MV" , "Maldives" ],
    [ "ML" , "Mali" ],
    [ "MT" , "Malta" ],
    [ "MH" , "Marshall Islands" ],
    [ "MR" , "Mauritania" ],
    [ "MU" , "Mauritius" ],
    [ "MX" , "Mexico" ],
    [ "FM" , "Micronesia (Federated States of)" ],
    [ "MC" , "Monaco" ],
    [ "MN" , "Mongolia" ],
    [ "ME" , "Montenegro" ],
    [ "MA" , "Morocco" ],
    [ "MZ" , "Mozambique" ],
    [ "MM" , "Myanmar" ],
    [ "NA" , "Namibia" ],
    [ "NR" , "Nauru" ],
    [ "NP" , "Nepal" ],
    [ "NL" , "Netherlands" ],
    [ "NZ" , "New Zealand" ],
    [ "NI" , "Nicaragua" ],
    [ "NE" , "Niger" ],
    [ "NG" , "Nigeria" ],
    [ "NU" , "Niue" ],
    [ "MK" , "North Macedonia" ],
    [ "NO" , "Norway" ],
    [ "OM" , "Oman" ],
    [ "PK" , "Pakistan" ],
    [ "PW" , "Palau" ],
    [ "PA" , "Panama" ],
    [ "PG" , "Papua New Guinea" ],
    [ "PY" , "Paraguay" ],
    [ "PE" , "Peru" ],
    [ "PH" , "Philippines" ],
    [ "PL" , "Poland" ],
    [ "PT" , "Portugal" ],
    [ "QA" , "Qatar" ],
    [ "KR" , "Republic of Korea" ],
    [ "MD" , "Republic of Moldova" ],
    [ "RO" , "Romania" ],
    [ "RU" , "Russian Federation" ],
    [ "RW" , "Rwanda" ],
    [ "KN" , "Saint Kitts and Nevis" ],
    [ "LC" , "Saint Lucia" ],
    [ "VC" , "Saint Vincent and the Grenadines" ],
    [ "WS" , "Samoa" ],
    [ "SM" , "San Marino" ],
    [ "ST" , "Sao Tome and Principe" ],
    [ "SA" , "Saudi Arabia" ],
    [ "SN" , "Senegal" ],
    [ "RS" , "Serbia" ],
    [ "SC" , "Seychelles" ],
    [ "SL" , "Sierra Leone" ],
    [ "SG" , "Singapore" ],
    [ "SK" , "Slovakia" ],
    [ "SI" , "Slovenia" ],
    [ "SB" , "Solomon Islands" ],
    [ "SO" , "Somalia" ],
    [ "ZA" , "South Africa" ],
    [ "SS" , "South Sudan" ],
    [ "ES" , "Spain" ],
    [ "LK" , "Sri Lanka" ],
    [ "SD" , "Sudan" ],
    [ "SR" , "Suriname" ],
    [ "SE" , "Sweden" ],
    [ "CH" , "Switzerland" ],
    [ "SY" , "Syrian Arab Republic" ],
    [ "TJ" , "Tajikistan" ],
    [ "TH" , "Thailand" ],
    [ "TL" , "Timor-Leste" ],
    [ "TG" , "Togo" ],
    [ "TK" , "Tokelau" ],
    [ "TO" , "Tonga" ],
    [ "TT" , "Trinidad and Tobago" ],
    [ "TN" , "Tunisia" ],
    [ "TR" , "Turkey" ],
    [ "TM" , "Turkmenistan" ],
    [ "TV" , "Tuvalu" ],
    [ "UG" , "Uganda" ],
    [ "UA" , "Ukraine" ],
    [ "AE" , "United Arab Emirates" ],
    [ "GB" , "United Kingdom of Great Britain and Northern Ireland" ],
    [ "TZ" , "United Republic of Tanzania" ],
    [ "US" , "United States of America" ],
    [ "UY" , "Uruguay" ],
    [ "UZ" , "Uzbekistan" ],
    [ "VU" , "Vanuatu" ],
    [ "VE" , "Venezuela (Bolivarian Republic of)" ],
    [ "VN" , "Viet Nam" ],
    [ "YE" , "Yemen" ],
    [ "ZM" , "Zambia" ],
    [ "ZW" , "Zimbabwe" ],

])


